import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const headerHeight = "90px";
export const mobileHeaderHeight = "64px";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  appBar: {
    backgroundColor: "#0C0C0C",
    left: 0,
    width: "100vw",
    padding: 0,
    // zIndex: (theme) => theme.zIndex.drawer + 1,
  },

  toolbar: {
    px: ({ spacing }) => `${spacing(4)} !important`,
    justifyContent: { xs: "center", sm: "space-between" },
  },

  logo: {
    width: "140px",
    display: "flex",
    justifyContent: "center",
    transition: "all 0.3s ease-out",
    cursor: "pointer",

    svg: {
      width: "100%",
    },

    ":hover": {
      transform: "scale(1.04)",
    },
  },

  actions: { display: "flex", gap: ({ spacing }) => spacing(2) },
};
